import Index from '@tunnel-components/@pages/incidents/fiche/container'

/**
 * @export Container
 */

export default Index;


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/incidents/fiche/index.ts